/**
 * window.ges: a small, stable handle on the running game for the browser
 * console and for the Playwright scripts in scripts/audit/. App functions are
 * module-scoped now, so this is the supported way to reach them from outside.
 * It only calls real app code; it adds no behaviour of its own.
 *
 *   ges.showTab("ma")            open any tab, including ones without a sidebar button
 *   ges.tab()                    the current tab id
 *   ges.refresh()                reload state from the backend and redraw
 *   ges.openResetSaveModal()     and the other openers below
 *   ges.world()                  the live 3D world, when the World tab is open in 3D
 */
import { getCurrentTab, mobileNavGroups, renderTab, showTab } from "./shell.js";
import { openResetSaveModal } from "./onboarding.js";
import { openAmountModal } from "../ui/modals.js";
import { openCountryExpansionModal, openExpandMarketModal } from "../views/core/government.js";

window.ges = Object.freeze({
  showTab,
  renderTab,
  tab: getCurrentTab,
  refresh: () => window.refreshAll(),
  mobileNavGroups,
  openResetSaveModal,
  openAmountModal,
  openExpandMarketModal,
  openCountryExpansionModal,
  // Views that register themselves on window (late-bound) are reached through it.
  openLaunchProductModal: (...a) => window.openLaunchProductModal(...a),
  openMeetCompanyModal: (...a) => window.openMeetCompanyModal(...a),
  openVisitCountryModal: (...a) => window.openVisitCountryModal(...a),
  // the live 3D world (views/world.js), or null: .level, .select(m), .showCity(m), .showInterior(), .perf()
  world: () => (window.__gesWorld ? window.__gesWorld() : null),
});
